var global = require('../internals/global');

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/host-report-errors.js
// module id = 442
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35